import React from "react"
import { useTheme } from "styled-components"

import ImagePreload from "components/image-preload"
import { Image, Container } from "./styles"

/**
 * A nested image that is placed in Featured product layouts or in Text with Media
 * components. Has 50% page width on desktop and up, but 100% width on anything lower.
 * The height is constrained to match the parent container, unless useOriginalAspectRatio
 * is set.
 */
const NestedImage = ({
  cloudinaryUrls,
  aspectRatios,
  minHeight,
  crop,
  hideOnPageLoad,
  dataExpId,
  ...props
}) => {
  const theme = useTheme()

  const images = [
    {
      screenSize: 993,
      url: cloudinaryUrls.desktop,
      transforms: `${crop ? "c_auto,g_auto" : "c_fit"},w_720,h_${
        minHeight || Math.round(720 * aspectRatios.desktop)
      },q_90,f_auto,fl_lossy`,
    },
    {
      screenSize: 500,
      url: cloudinaryUrls.tablet,
      transforms: `${crop ? "c_fill,g_auto" : "c_fit"},w_992,h_${
        aspectRatios.tablet > 1.0001 ? 350 : Math.round(992 * aspectRatios.tablet)
      },q_90,f_auto,fl_lossy`,
    },
    {
      url: cloudinaryUrls.mobile,
      transforms: `${crop ? "c_fill,g_auto" : "c_fit"},w_500,h_${
        aspectRatios.mobile > 1.0001 ? 350 : Math.round(500 * aspectRatios.mobile)
      },q_90,f_auto,fl_lossy`,
    },
  ]

  return (
    <Container data-exp-id={dataExpId} hideOnPageLoad={hideOnPageLoad}>
      {theme.component.onTop && <ImagePreload images={images} />}
      <Image {...props} aspectRatios={aspectRatios} images={images} lazy={!theme.component.onTop} />
    </Container>
  )
}

export default NestedImage
